import { render, staticRenderFns } from "./CurationC.vue?vue&type=template&id=4557eed0&scoped=true&"
import script from "./CurationC.vue?vue&type=script&lang=js&"
export * from "./CurationC.vue?vue&type=script&lang=js&"
import style0 from "./CurationC.vue?vue&type=style&index=0&id=4557eed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557eed0",
  null
  
)

export default component.exports